export default __webpack_public_path__ + "6bffbe898a51e127ce89211e9271cb46.svg";